import React, { useEffect, useState } from 'react';
import { getHourLists } from 'utils/time';
import BookingTimeBlock from './BookingTimeBlock';
import {
  formatBookedIndex,
  formatDisabledIndex,
  formatSelectedIndex
} from 'utils/formatBookingIndex';

export default function BookingTimeTable({
  bookings,
  buildingTimezone,
  start,
  end,
  editStart,
  editEnd,
  updateStart,
  updateEnd,
  openTime,
  closeTime,
  selectedDate,
  bookingStartDate,
  bookingEndDate
}: any) {
  const hourlists = getHourLists();
  const [disabledIndexList, setDisabledIndexList] = useState<number[]>([]);
  const [selectedIndexList, setSelectedIndexList] = useState<number[]>([]);
  const [bookedIndexList, setBookedIndexList] = useState<number[]>([]);

  // Get all disabled block index
  useEffect(() => {
    if (selectedDate) {
      setDisabledIndexList(
        formatDisabledIndex(openTime, closeTime, selectedDate, buildingTimezone)
      );
      setSelectedIndexList(formatSelectedIndex(start, end));
    }
  }, [closeTime, end, openTime, selectedDate, start, buildingTimezone]);

  useEffect(() => {
    if (bookings || selectedDate) {
      setBookedIndexList(
        formatBookedIndex(
          bookings,
          selectedDate,
          editStart,
          editEnd,
          buildingTimezone,
          bookingStartDate,
          bookingEndDate
        )
      );
    }
  }, [
    bookings,
    editEnd,
    editStart,
    selectedDate,
    buildingTimezone,
    bookingStartDate,
    bookingEndDate
  ]);

  // Update all the Status
  const getStatus = (index: number) => {
    if (disabledIndexList.includes(index)) {
      return 'disabled';
    } else if (selectedIndexList.includes(index)) {
      return 'selected';
    } else if (bookedIndexList.includes(index)) {
      return 'booked';
    }
    return 'available';
  };

  return (
    <div className="flex flex-wrap mb-6 w-full">
      {hourlists &&
        hourlists.map((hour, index): any => {
          const min = hour.split(':')[1].slice(0, 2);
          const label = hour.replace(':00', '');
          if (min === '00') {
            return (
              <BookingTimeBlock
                key={index}
                index={index}
                hour={label}
                booking={bookedIndexList}
                status={getStatus(index)}
                width={'w-[24.53px]'}
                displayHour={true}
                start={start}
                end={end}
                updateStart={updateStart}
                updateEnd={updateEnd}
              />
            );
          } else {
            return (
              <BookingTimeBlock
                key={index}
                index={index}
                hour={label}
                booking={bookedIndexList}
                status={getStatus(index)}
                width={'w-[22.44px]'}
                displayHour={false}
                start={start}
                end={end}
                updateStart={updateStart}
                updateEnd={updateEnd}
              />
            );
          }
        })}
    </div>
  );
}
